import React, { memo } from 'react'
import { BtAlert, BtText } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'

interface AddNewBankAccountFlow_ERRORProps {
  onClose: () => void
}

export const AddNewBankAccountFlow_ERROR: React.FC<AddNewBankAccountFlow_ERRORProps> =
  memo(({ onClose }) => {
    const { t } = useTranslation('global')

    return (
      <BtAlert
        visible={true}
        onClose={onClose}
        title={t('Wallet.account_alert_title')}
        width={500}
        type={'danger'}
        buttons={[
          {
            label: t('Wallet.account_alert_button'),
            onPress: onClose,
          },
        ]}
      >
        <BtText
          testID={'add-new-bank-account-error-message'}
          size={18}
          style={{ lineHeight: 26, textAlign: 'center' }}
        >
          {t('Wallet.account_alert_text')}
        </BtText>
      </BtAlert>
    )
  })
